import PayActionsPopup from './PayActionsPopup';

export default PayActionsPopup;
